/**
 * Конфиг путей к изображениям для визуальных карточек категорий Wiki.
 * Картинки хранятся в public/img/wiki/categories/
 *
 * Структура: source -> путь к изображению
 * Используется для всех уровней иерархии (категории, подкатегории, типы, подтипы, расы, классы и т.д.)
 */

export interface CategoryImageConfig {
  imagePath: string;
}

// Конфиг по source
export const wikiCategoryImagesConfig: Record<string, CategoryImageConfig> = {
  items: { imagePath: '/img/wiki/categories/items.webp' },
  classes: { imagePath: '/img/wiki/categories/classes.webp' },
  npc: { imagePath: '/img/wiki/categories/npc.webp' },

  other: { imagePath: '/img/wiki/categories/item/others.webp' },
  accessories: { imagePath: '/img/wiki/categories/item/accessories.webp' },
  weapon: { imagePath: '/img/wiki/categories/item/weapon.webp' },
  bijouterie: { imagePath: '/img/wiki/categories/item/bijouterie.webp' },
  recipes: { imagePath: '/img/wiki/categories/item/recipes.webp' },
  equipment: { imagePath: '/img/wiki/categories/item/equipment.webp' },

  monsters: { imagePath: '/img/wiki/categories/npc/monsters.webp' },
  squads: { imagePath: '/img/wiki/categories/npc/squads.webp' },
  "scientific and production center": { imagePath: '/img/wiki/categories/npc/npc.webp' },
  "raid bosses": { imagePath: '/img/wiki/categories/npc/raid_bosses.webp' },

  orcs: { imagePath: '/img/wiki/categories/race/orc.webp' },
  humans: { imagePath: '/img/wiki/categories/race/human.webp' },
  elves: { imagePath: '/img/wiki/categories/race/elf.webp' },
  dwarves: { imagePath: '/img/wiki/categories/race/dwarf.webp' },
  drow: { imagePath: '/img/wiki/categories/race/dark_elf.webp' },
};

// Дефолтное изображение для категорий без конфига
export const DEFAULT_CATEGORY_IMAGE = '/img/wiki/categories/default.webp';

/**
 * Получить путь к изображению для категории по source
 * @param source - source категории (weapons, armors, human и т.д.)
 * @returns путь к изображению или дефолтное изображение
 */
export function getCategoryImage(source: string | undefined | null): string {
  if (!source) return DEFAULT_CATEGORY_IMAGE;

  const normalizedSource = source.toLowerCase();
  const config = wikiCategoryImagesConfig[normalizedSource];

  if (config) {
    return config.imagePath;
  }

  return DEFAULT_CATEGORY_IMAGE;
}
